import { c as changeItemQuantity, a as contexts, removeItemSameTimestamp, removeTestCandle } from './cart-cce84c00.js';
import { E as EVENTS } from './events-58bc9098.js';

class CartItem extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      changePending: "change-pending",
      deletePending: "delete-pending",
    };

    this.selectors = {
      errorDisplay: "[js-error-display]",
      deleteButton: "[js-delete-button]",
      cartItem: "cart-item"
    };
  }

  connectedCallback() {
    this.controller = new AbortController();

    const eventOptions = {
      signal: this.controller.signal,
    };

    this.cartItemKey = this.dataset.cartItemKey;
    this.timestampProperties = this.dataset.timestamp
    this.isCandleTest = this.dataset.isCandleTest || false
    this.isHandLotionTest = this.dataset.isHandTest || false


    // Because the cart re-renders cart items on any update, we can
    // use the data attribute to know the last valid quantity.  This
    // is necessary to revert things on quantity change error
    this.lastConfirmedQuantity = this.dataset.cartItemQuantity;

    this.quantityInput = this.querySelector("quantity-input");
    this.quantityInput.addEventListener(
      EVENTS.QUANTITY_INPUT_CHANGE,
      (event) => {
        this.dispatchEvent(
          new CustomEvent(EVENTS.CART_ITEM_CHANGE_PENDING, {
            bubbles: true,
          }),
        );

        this.classList.add(this.classes.changePending);

        const quantity = event.detail.quantity;

        if (quantity === 0 && this.timestampProperties) {
          if (this.isCandleTest) {
            return removeTestCandle(this, this.cartItemKey, 0, contexts.cartDrawer, this.timestampProperties)
          }

          const cartItems = Array.from(document.querySelectorAll(this.selectors.cartItem))
          const itemSameTimestamp = this.getCartItemKeySameTimestamp(
            this.timestampProperties,
            cartItems
          )

          return itemSameTimestamp.length === 2 && !this.isHandLotionTest
            ? removeItemSameTimestamp(this, itemSameTimestamp, contexts.cartDrawer)
            : changeItemQuantity(this, this.cartItemKey, quantity, contexts.cartDrawer)
        }

        changeItemQuantity(this, this.cartItemKey, quantity, contexts.cartDrawer)
      },
      eventOptions,
    );

    this.deleteButton = this.querySelector(this.selectors.deleteButton);

    this.deleteButton.addEventListener(
      "click",
      () => {
        this.classList.add(this.classes.deletePending);
        this.dispatchEvent(
          new CustomEvent(EVENTS.CART_ITEM_CHANGE_PENDING, {
            bubbles: true,
          }),
        );

        if (this.isCandleTest) {
          return removeTestCandle(this, this.cartItemKey, 0, contexts.cartDrawer, this.timestampProperties)
        } else {
          const cartItems = Array.from(document.querySelectorAll(this.selectors.cartItem))
          const itemSameTimestamp = this.timestampProperties
          ? this.getCartItemKeySameTimestamp(this.timestampProperties, cartItems)
          : []

          if (itemSameTimestamp && itemSameTimestamp.length) {
            return itemSameTimestamp.length === 2 && !this.isHandLotionTest ? removeItemSameTimestamp(this, itemSameTimestamp, contexts.cartDrawer) : changeItemQuantity(this, this.cartItemKey, 0, contexts.cartDrawer)
          }

          changeItemQuantity(this, this.cartItemKey, 0, contexts.cartDrawer)

        }

      },
      eventOptions,
    );

    this.addEventListener(
      EVENTS.CART_ITEM_CHANGE_ERROR,
      (event) => {
        if (this.cartItemKey === event.detail.cartItemKeyOrId) {
          this.#displayErrorMessage(event.detail.errorMessage);
          this.classList.remove(this.classes.changePending);
          if (this.lastConfirmedQuantity !== undefined) {
            this.quantityInput.setQuantity(this.lastConfirmedQuantity);
          }
        }
      },
      eventOptions,
    );
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  getCartItemKeySameTimestamp(time, items) {
    return items.reduce((keys, item) => {
      if (item.dataset.timestamp === time) keys.push(item.dataset.cartItemKey)
      return keys
    }, [])
  }

  #displayErrorMessage(message) {
    this.errorDisplay = this.querySelector(this.selectors.errorDisplay);
    this.errorDisplay.hidden = false;
    this.errorDisplay.innerText = message;
  }
}

if (!customElements.get("cart-item")) {
  customElements.define("cart-item", CartItem);
}
